import { AppTypeAtom } from 'Atoms';
import { useAtom } from 'jotai';
import { AppType } from 'Types/Auth.types';

export const useAppType = (): AppType | null => {
  const [appType] = useAtom(AppTypeAtom);

  return appType;
};
